import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getApiV1ArticleTypeList } from '@/api/sdk.gen'
import { useRegionStore } from '@/stores/region-store'

export const useArticleStore = defineStore('article-store', () => {
  const yearList = ref<number[]>([])

  async function fetchYearListIfEmpty() {
    if (yearList.value.length > 0) return
    const regionStore = useRegionStore()
    const lotteryType = regionStore.region === 'hk' ? 1 : 2
    const res = await getApiV1ArticleTypeList({ query: { year: 9999, lotteryType } })
    yearList.value = res.data?.data?.yearList ?? []
  }

  return {
    yearList,
    fetchYearListIfEmpty,
  }
})
